<script>
  import {next_up_store} from "./stores/next_up_store";
  import UpNextVideos from "./UpNextVideos.svelte";
  import BigGreenCircleTick from "./BigGreenCircleTick.svelte";
  import ShareThisVideoView from "./ShareThisVideoView.svelte";
  import RelatedVideos from "./RelatedVideos.svelte";

  export let video;
  export let playlist = false;
  export let playlistTitle = ""
  $: ({finished, videos} = $next_up_store)

</script>

<div class="vec-flex vec-h-full vec-m-auto">
  {#if finished}
      <div class="vec-w-100 vec-m-auto vec-py-5">
        <BigGreenCircleTick />
        <h2 class="vec-text-center">
          Well Done! You Have Finished {playlistTitle}
        </h2>
      </div>
  {:else}
    <UpNextVideos
      videos={videos}
      on:video-clicked
    />
  {/if}
</div>
